module.exports = __webpack_public_path__ + "img/Mobile_home_img4.645792bd.png";